import {PayoffReasonEnum} from '@/services/api-clients';

export function payoffReasonIconColorFilter(status: PayoffReasonEnum): string[] {
  switch (status) {
    case PayoffReasonEnum.VehicleRent: return ['success'];
    case PayoffReasonEnum.ResourceConsumption: return ['primary'];
    case PayoffReasonEnum.VehicleDamage: return ['warning'];
    case PayoffReasonEnum.DayOff: return ['blue-grey', 'lighten-2']
    case PayoffReasonEnum.Referral: return ['success'];
    default: return [''];
  }
}
